<template>
    <div class="theme-tabs garage">
        <div class="tabs is-centered">
            <ul>
                <a :class="{ 'is-active': inJapan }" @click="setCarsQuerySection($carsSectionInJapan)">
                    <span class="icon">
                        <i class="fas fa-store-alt"></i>
                    </span>
                    In Japan
                </a>
                <a :class="{ 'is-active': onTheWay }" @click="setCarsQuerySection($carsSectionOnTheWay)">
                    <span class="icon">
                        <i class="fas fa-ship"></i>
                    </span>
                    On The Water
                </a>
                <a :class="{ 'is-active': arrived }" @click="setCarsQuerySection($carsSectionArrived)">
                    <span class="icon">
                        <i class="fas fa-home"></i>
                    </span>
                    Arrived
                </a>
                <a :class="{ 'is-active': allCars }" @click="setCarsQuerySection($carsSectionAllCars)">
                    <span class="icon">
                        <i class="fas fa-layer-group"></i>
                    </span>
                    All Cars
                </a>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            inJapan() {
                return this.$store.getters.getCarsQuery.section === this.$carsSectionInJapan
            },
            booked() {
                return this.$store.getters.getCarsQuery.section === this.$carsSectionBooked
            },
            onTheWay() {
                return this.$store.getters.getCarsQuery.section === this.$carsSectionOnTheWay
            },
            arrived() {
                return this.$store.getters.getCarsQuery.section === this.$carsSectionArrived
            },
            allCars() {
                return this.$store.getters.getCarsQuery.section === this.$carsSectionAllCars
            }
        },
        methods: {
            setCarsQuerySection(section) {
                const page = 1
                this.$store.dispatch('setCarsQueryFieldValue', { field: 'order_type', value: 'DESC' })

                if (section === this.$carsSectionInJapan) {
                    this.$store.dispatch('setCarsQueryFieldValue', { field: 'order_column', value: 'created_at' })
                }

                if (section === this.$carsSectionBooked) {
                    this.$store.dispatch('setCarsQueryFieldValue', { field: 'order_column', value: 'shipping_group_id' })
                }

                if (section === this.$carsSectionOnTheWay) {
                    this.$store.dispatch('setCarsQueryFieldValue', { field: 'order_column', value: 'shipping_group_id' })
                }

                if (section === this.$carsSectionArrived) {
                    this.$store.dispatch('setCarsQueryFieldValue', { field: 'order_column', value: 'shipping_group_id' })
                }

                if (section === this.$carsSectionAllCars) {
                    this.$store.dispatch('setCarsQueryFieldValue', { field: 'order_column', value: 'created_at' })
                }

                this.$store.dispatch('setCarsQueryFieldValue', { field: 'section', value: section })
                this.$store.dispatch('loadMoreCars', page)
            }
        }
    }
</script>

<style scoped>
    .is-active {
        color: #00d2b2;
    }
</style>



// WEBPACK FOOTER //
// src/components/Cars/CarsNavigation.vue